export default function RulesBaseController(
    $scope,
    rules,
    anchorLink
) {
    'ngInject';

            /**
             * Flight rules
             */
            $scope.rules = rules.rules;

            /**
             * Flight rules exist
             */
            $scope.exist = $scope.rules && $scope.rules.length > 0;

            /**
             * Penalties should be expanded by default
             */
            if (rules.isExist && $scope.rules[0].Description === 'Penalties') {
                $scope.rules[0].expanded = true;
            }

            /**
             * Expand section with specified anchor
             */
            if (anchorLink) {
                _.each(rules.rules, function(rule) {
                    if (rule.Description === anchorLink) {
                        rule.expanded = true;
                    }
                });
            }

            $scope.toggleGroup = function(index) {
                $scope.rules[index].expanded = !$scope.rules[index].expanded;
            };
}



// WEBPACK FOOTER //
// ./src/app/modules/base/controllers/flights/rulesBaseCtrl.js